import React from "react";

const AnalyticalReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48.879"
      height="42.311"
      viewBox="0 0 48.879 42.311"
    >
      <g id="db94" transform="translate(-149.163 -179.947)">
        <path
          id="Path_1792"
          data-name="Path 1792"
          d="M193.2,340.96h2.705v8.83H193.2Z"
          transform="translate(-39.291 -143.66)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1793"
          data-name="Path 1793"
          d="M240.56,291.7h2.705v14.138H240.56Z"
          transform="translate(-81.546 -99.709)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1794"
          data-name="Path 1794"
          d="M287.91,321.54h2.705v10.923H287.91Z"
          transform="translate(-123.793 -126.333)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1795"
          data-name="Path 1795"
          d="M335.27,268.97h2.705v16.587H335.27Z"
          transform="translate(-166.049 -79.429)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1796"
          data-name="Path 1796"
          d="M382.63,250.5h2.705v18.578H382.63Z"
          transform="translate(-208.305 -62.949)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1797"
          data-name="Path 1797"
          d="M215.411,211.67a1.258,1.258,0,0,0-1.225,1.072l-3.011,1.072a1.227,1.227,0,0,0-2.093.868,1.492,1.492,0,0,0,.1.459l-3.725,4.032a.87.87,0,0,0-.357-.051,1.025,1.025,0,0,0-.663.2l-3.216-2.041v-.153a1.225,1.225,0,0,0-2.45,0,1.492,1.492,0,0,0,.1.459l-3.624,3.879a.871.871,0,0,0-.357-.051,1.225,1.225,0,1,0,1.225,1.225,1.492,1.492,0,0,0-.1-.459l3.624-3.879a.869.869,0,0,0,.357.051,1.025,1.025,0,0,0,.663-.2l3.216,2.041v.153a1.225,1.225,0,0,0,2.45,0,1.493,1.493,0,0,0-.1-.459l3.675-4.032a.869.869,0,0,0,.357.051,1.258,1.258,0,0,0,1.225-1.072l3.011-1.072a1.227,1.227,0,0,0,2.093-.868,1.169,1.169,0,0,0-1.175-1.225Z"
          transform="translate(-39.708 -28.304)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1798"
          data-name="Path 1798"
          d="M523.76,273.23h3.726v1.021H523.76Z"
          transform="translate(-334.225 -83.23)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1799"
          data-name="Path 1799"
          d="M497.71,273.23H499.5v1.021H497.71Z"
          transform="translate(-310.982 -83.23)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1800"
          data-name="Path 1800"
          d="M435.67,286.97h13.219v1.021H435.67Z"
          transform="translate(-255.629 -95.489)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1801"
          data-name="Path 1801"
          d="M469.77,203.368h3.062a3.14,3.14,0,0,0-3.062-3.062Z"
          transform="translate(-286.054 -18.165)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1802"
          data-name="Path 1802"
          d="M438.738,208.682v-3.165a3.149,3.149,0,0,0-3.062,3.113,3.113,3.113,0,0,0,6.226.051Z"
          transform="translate(-255.634 -22.814)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1803"
          data-name="Path 1803"
          d="M546.49,239.61l1.939,2.195a3.278,3.278,0,0,0,.97-1.735Z"
          transform="translate(-354.505 -53.233)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1804"
          data-name="Path 1804"
          d="M510.1,208.52l3.266.51c0-.153.051-.255.051-.408a3.113,3.113,0,1,0-3.113,3.113,2.984,2.984,0,0,0,2.041-.766Z"
          transform="translate(-319.439 -22.806)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1805"
          data-name="Path 1805"
          d="M197.038,209.549a2.42,2.42,0,0,0,.919-1.888V182.4a2.45,2.45,0,0,0-2.45-2.45H151.613a2.45,2.45,0,0,0-2.45,2.45v25.264a2.45,2.45,0,0,0,2.45,2.45h7.4v1.582a.511.511,0,0,0,.51.51h15.363a5.024,5.024,0,0,0,.153,1.225l1.327,7.707a1.322,1.322,0,0,0,1.327,1.123h17.557a1.322,1.322,0,0,0,1.327-1.123l1.327-7.707a4.371,4.371,0,0,0-.867-3.879Zm-10.616,11.943-1.888-11.127,1.072-1.378-.868-1.276a4.788,4.788,0,0,0,3.369,0l-.868,1.276,1.072,1.378Zm0-28.225c-3.726,0-6.176,3.011-6.176,6.686a9.093,9.093,0,0,0,3.216,6.992l-4.951.97a5.061,5.061,0,0,0-1.531.613H151.613a.915.915,0,0,1-.919-.919V182.4a.915.915,0,0,1,.919-.919h43.894a.915.915,0,0,1,.919.919v25.264a.939.939,0,0,1-.613.868,4.7,4.7,0,0,0-1.48-.562l-4.951-.97a9.093,9.093,0,0,0,3.216-6.992c.051-3.726-2.45-6.738-6.176-6.738Z"
          transform="translate(0 0)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};
export default AnalyticalReportIcon;
